<template>
	<div
		class="courseVideo"
		:style="{
			marginTop: data.marginTop + 'px',
			paddingTop: data.paddingTop + 'px',
			paddingLeft: data.paddingLeft + '%',
			paddingRight: data.paddingRight + '%',
		}"
	>
		<div v-if="data.content || data.data.length > 0">
			<!-- 灵源加载数据样式 -->
			<div v-show="data.styleSelect == 'is_style_ly'">
				<img src="../../assets/img/ly/l3.png" class="course1" />
				<div class="course-box">
					<div class="course-detail">
						<div class="video-box" v-for="(item, index) in data.data" :key="index" @click="goToview(index)">
							<img v-if="data.listImage" :src="data.listImage" class="video-alt" />
							<img v-else src="../../assets/img/ly/ly_alt.png" class="video-alt" />
							<div class="right-box">
								<div class="video-center">
									<div class="video-title">{{ item.title }}</div>
									<div class="video-subtitle">{{ item.subTitle }}</div>
								</div>
								<img src="../../assets/img/ly/ly_right.png" class="video-right" />
							</div>
						</div>
					</div>
				</div>
				<img src="../../assets/img/ly/l6.png" class="course2" />
			</div>
			<!-- 膏方加载数据样式 -->
			<div v-show="data.styleSelect == 'is_style_gf'">
				<img src="../../assets/img/gf-ver1/gfbk7.png" class="course1" />
				<div class="video-content">
					<div class="video-line" v-for="(item, index) in data.data" :key="index" @click="goToview(index)">
						<div class="video-left">
							<img v-if="data.listImage" :src="data.listImage" />
							<img v-else src="../../assets/img/gf-ver1/video_2.png" />
							<div class="video-text">{{ item.title }}</div>
						</div>
						<img src="../../assets/img/gf-ver1/video_3.png" class="video-right" />
					</div>
				</div>
				<img src="../../assets/img/gf-ver1/gfbk9.png" class="course1" />
			</div>
		</div>

		<div v-else>
			<!-- 灵源默认样式 -->
			<div v-show="data.styleSelect == 'is_style_ly'">
				<img src="../../assets/img/ly/l3.png" class="course1" />
				<div class="course-box">
					<div class="course-detail">
						<div class="video-box">
							<img src="../../assets/img/ly/ly_alt.png" class="video-alt" />
							<div class="right-box">
								<div class="video-center">
									<div class="video-title">第一讲</div>
									<div class="video-subtitle">普通感冒</div>
								</div>
								<img src="../../assets/img/ly/ly_right.png" class="video-right" />
							</div>
						</div>
						<div class="video-box">
							<img src="../../assets/img/ly/ly_alt.png" class="video-alt" />
							<div class="right-box">
								<div class="video-center">
									<div class="video-title">第二讲</div>
									<div class="video-subtitle">流行性感冒与风温、暑温</div>
								</div>
								<img src="../../assets/img/ly/ly_right.png" class="video-right" />
							</div>
						</div>
						<div class="video-box">
							<img src="../../assets/img/ly/ly_alt.png" class="video-alt" />
							<div class="right-box">
								<div class="video-center">
									<div class="video-title">第三讲</div>
									<div class="video-subtitle">痊夏、秋燥、痢疾</div>
								</div>
								<img src="../../assets/img/ly/ly_right.png" class="video-right" />
							</div>
						</div>
					</div>
				</div>
				<img src="../../assets/img/ly/l6.png" class="course2" />
			</div>
			<!-- 膏方默认样式 -->
			<div v-show="data.styleSelect == 'is_style_gf'">
				<img src="../../assets/img/gf-ver1/gfbk7.png" class="course1" />
				<div class="video-content">
					<div class="video-line">
						<div class="video-left">
							<img src="../../assets/img/gf-ver1/video_2.png" />
							<div class="video-text">第一讲虚劳（上）</div>
						</div>
						<img src="../../assets/img/gf-ver1/video_3.png" class="video-right" />
					</div>
					<div class="video-line">
						<div class="video-left">
							<img src="../../assets/img/gf-ver1/video_2.png" />
							<div class="video-text">第一讲虚劳（中）</div>
						</div>
						<img src="../../assets/img/gf-ver1/video_3.png" class="video-right" />
					</div>
					<div class="video-line">
						<div class="video-left">
							<img src="../../assets/img/gf-ver1/video_2.png" />
							<div class="video-text">第一讲虚劳（下）</div>
						</div>
						<img src="../../assets/img/gf-ver1/video_3.png" class="video-right" />
					</div>
				</div>
				<img src="../../assets/img/gf-ver1/gfbk9.png" class="course1" />
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import { Toast } from 'vant';
export default {
	name: 'courseVideo',
	props: ['data'],

	methods: {
		goToview(index) {
			const params = { aiId: this.data.aiId, abId: this.data.abId, apName: '课程介绍落地页' };
			let url = process.env.VUE_APP_BASE_API + '/act/page/listH5';
			axios.get(url, { params: params, headers: { Authorization: 'Bearer ' + this.data.token, clientOs: 'h5' } }).then((res) => {
				if (res.data.code == 200) {
					if (res.data.rows && res.data.rows.length > 0) this.$router.push({ path: '/H5Page?id=' + res.data.rows[0].apId + '&pageNum=' + index });
				} else {
					Toast(res.data.msg);
				}
			});
		},
	},
};
</script>

<style lang="scss" scoped>
// @import '../../assets/css/curriculum.scss';
.course1,
.course2 {
	width: 100%;
	height: 100%;
	display: block;
}
.course-box {
	width: 100%;
	background-image: url('../../assets/img/ly/l5.png');
	background-repeat: no-repeat;
	background-size: 100% 100%;
}
.course-detail {
	position: relative;
	width: 90%;
	padding: 1px 20px;
	margin: 0 auto;
	box-sizing: border-box;
	font-size: 0;
	background: #fcf6de;
	border-radius: 7px;
}
.course-detail:last-child {
	border-bottom: none;
	padding-bottom: 0;
}
.video-box {
	display: flex;
	justify-content: space-between;
	align-items: center;
	position: relative;
	width: 100%;
	height: 50px;
	border-bottom: 1px solid #f1e9df;
}
.video-alt {
	width: 33px;
	height: 31px;
}
.right-box {
	flex: 1;
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 100%;
}
.video-right {
	width: 7px;
	height: 11px;
}
.video-center {
	margin-left: 10px;
	margin-top: -8px;
}
.video-title {
	height: 11px;
	font-size: 11px;
	font-weight: bold;
	color: #7c5401;
}
.video-subtitle {
	padding-top: 6px;
	height: 14px;
	font-size: 14px;
	font-weight: 500;
	color: #7c5401;
}

//膏方样式
.video-content {
	padding: 0 36px;
	background: url('../../assets/img/gf-ver1/gfbk8.png') no-repeat;
	background-size: 100% 100%;
}
.video-line {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 10px 0;
	border-bottom: 1px solid #dfdfdf;
}
.video-line:last-child {
	border-bottom: none;
}
.video-left {
	display: flex;
	align-items: center;
	font-size: 14px;
	font-weight: bold;
	color: #204f82;
}
.video-left > img {
	width: 17px;
	height: 15px;
	margin-right: 12px;
}
.video-right {
	width: 6px;
	height: 9px;
}
</style>